const initialState = {
  hasNotification: false,
  text: '',
  type: ''
}

export const ACTION_TYPES = {
  SHOW_NOTIFICATION: 'SHOW_NOTIFICATION',
  HIDE_NOTIFICATION: 'HIDE_NOTIFICATION'
}

export const showNotification = (type, text) => ({
  type: ACTION_TYPES.SHOW_NOTIFICATION,
  payload: { type, text }
})

export const hideNotification = () => ({
  type: ACTION_TYPES.HIDE_NOTIFICATION
})

const notification = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTION_TYPES.SHOW_NOTIFICATION: {
      return {
        ...state,
        hasNotification: true,
        text: payload.text,
        type: payload.type
      }
    }

    case ACTION_TYPES.HIDE_NOTIFICATION:
      return {
        ...state,
        hasNotification: false
      }
    default:
      return state
  }
}

export default notification
